export default __webpack_public_path__ + "static/media/darkPhone.6337d07a.svg";